import type { FC, SVGProps } from 'react';

export const ChevronLeftIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="14"
      height="14"
      fill="currentColor"
      viewBox="0 0 14 14"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_2002_5733)">
        <rect width="14" height="14" fillOpacity="0.01" fill="currentColor" />
        <path
          fill="currentColor"
          d="M10.111 1.10441C10.1922 1.04035 10.3131 1.09836 10.3131 1.20305V2.41105C10.313 2.48748 10.2767 2.56054 10.2174 2.60734L4.59241 6.99992L10.2174 11.3905C10.2767 11.4373 10.313 11.5104 10.3131 11.5868V12.7948C10.3131 12.8995 10.1938 12.9575 10.111 12.8935L3.06799 7.39152C3.0082 7.34502 2.9597 7.28573 2.92639 7.21769C2.89308 7.14959 2.87561 7.07476 2.87561 6.99894C2.87561 6.92314 2.89308 6.84829 2.92639 6.78019C2.9597 6.71217 3.0082 6.65286 3.06799 6.60637L10.111 1.10441Z"
        />
      </g>
      <defs>
        <clipPath id="clip0_2002_5733">
          <rect width="14" height="14" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  );
};
